// src/components/ContactInfo.js
import React, { useState } from "react";
import "../styles/ContactInfo.css";
import StoreInfo from "../components/StoreInfo";

const ContactInfo = () => {
  const [showContacts, setShowContacts] = useState(false);

  const contacts = [
    {
      name: "Yaily - Propietaria",
      phone: "+5354586685",
      email: "serviciotiendayalily@gmail.com",
      role: "Atención al cliente",
    },
    // {
    //   name: "Liudmila - Ventas",
    //   phone: "573001234567", // Código país + número sin + ni espacios
    //   email: "reservastiendaema@gmail.com",
    //   role: "Reservas de productos",
    // },
    // {
    //   name: "Yanet Ruiz - Reservas",
    //   phone: "5356265816",
    //   email: "ventastiendaema@gmail.com",
    //   role: "Cajero-Vendedor",
    // },
  ];

  return (
    <div className="contact-info">
      <button
        className="contact-toggle-btn"
        onClick={() => setShowContacts(!showContacts)}
      >
        📞 Contacto y Atención
      </button>

      {showContacts && (
        <div className="contact-card">
          <StoreInfo />
          <h3>📱 Nuestros canales de atención</h3>
          {contacts.map((contact, index) => (
            <div key={index} className="contact-item">
              <div className="contact-details">
                <strong>{contact.name}</strong>
                <span className="contact-role">{contact.role}</span>
              </div>
              <div className="contact-actions">
                <a
                  href={`https://wa.me/${contact.phone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-whatsapp"
                >
                  💬 WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactInfo;
